import { Box, styled } from '@mui/material';

export const SectionHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  padding: theme.spacing(1, 2),
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),
  fontWeight: 'bold',
  fontSize: '14px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  '@media print': {
    backgroundColor: '#1976d2 !important',
    color: '#ffffff !important',
    pageBreakInside: 'avoid',
    pageBreakAfter: 'avoid',

    // Hide expand/collapse buttons
    '& .MuiIconButton-root': {
      display: 'none !important',
    },
  },
}));
